import axios from "axios";
import { ISSUE } from "../_constants/actionConstants";
import { BASE_URL } from "../_constants/urlConstants";
import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";

const addIssue = issue => dispatch =>
  new Promise(resolve => {
    dispatch({ type: ISSUE.ADD_ISSUE });
    const apiEndpoint = BASE_URL + "/api/Issues/Add";
    axios
      .post(apiEndpoint, issue)
      .then(response => {
        dispatch({
          type: ISSUE.ADD_ISSUE_FULFILLED,
          issue: response.data
        });
        console.log(ISSUE.ADD_ISSUE_FULFILLED, response.data);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = ISSUE.ADD_ISSUE_FULFILLED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.error(ISSUE.ADD_ISSUE_FULFILLED, err.response.data);
      });
  });

const followIssue = issueFollower => dispatch =>
  new Promise(resolve => {
    dispatch({ type: ISSUE.FOLLOW_ISSUE });
    const apiEndpoint = BASE_URL + "/api/Issues/FollowIssue";
    axios
      .post(apiEndpoint, issueFollower)
      .then(response => {
        dispatch({
          type: ISSUE.FOLLOW_ISSUE_FULFILLED,
          issue: response.data
        });
        console.log(ISSUE.FOLLOW_ISSUE_FULFILLED);
        resolve();
      })
      .catch(err => {
        const errorId = getUUID();
        const type = ISSUE.FOLLOW_ISSUE_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.error(ISSUE.FOLLOW_ISSUE_REJECTED, err.response.data);
      });
  });

const unfollowIssue = issueFollower => dispatch =>
  new Promise(resolve => {
    dispatch({ type: ISSUE.UNFOLLOW_ISSUE });
    const apiEndpoint = BASE_URL + "/api/Issues/UnfollowIssue";
    axios
      .post(apiEndpoint, issueFollower)
      .then(response => {
        dispatch({
          type: ISSUE.UNFOLLOW_ISSUE_FULFILLED,
          issue: response.data
        });
        console.log(ISSUE.UNFOLLOW_ISSUE_FULFILLED);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = ISSUE.UNFOLLOW_ISSUE_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.error(ISSUE.UNFOLLOW_ISSUE_REJECTED, err.response.data);
      });
  });

const addPost = issuePost => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: ISSUE.ADD_POST });
    const apiEndpoint = BASE_URL + "/api/Issues/AddPost";
    axios
      .post(apiEndpoint, issuePost)
      .then(response => {
        dispatch({
          type: ISSUE.ADD_POST_FULFILLED,
          issue: response.data
        });
        console.log(ISSUE.ADD_POST_FULFILLED);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = ISSUE.ADD_POST_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.error(ISSUE.ADD_POST_REJECTED, err.response.data);
      });
  });

const likePost = postLike => dispatch =>
  new Promise(resolve => {
    dispatch({ type: ISSUE.LIKE_POST });
    const apiEndpoint = BASE_URL + "/api/Issues/AddPostLike";
    axios
      .post(apiEndpoint, postLike)
      .then(response => {
        dispatch({
          type: ISSUE.LIKE_POST_FULFILLED,
          issue: response.data.issue,
          issueList: response.data.issueList
        });
        console.log(ISSUE.LIKE_POST_FULFILLED, response.data);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = ISSUE.LIKE_POST_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.error(ISSUE.LIKE_POST_REJECTED, err.response.data);
      });
  });

const getIssue = (idCheckoutToken, issueId) => (dispatch, getState) =>
  new Promise(resolve => {
    dispatch({ type: ISSUE.FETCH_ISSUE });
    const apiEndpoint = BASE_URL + "/api/Issues/GetById/?issueId=" + issueId;
    axios
      .get(apiEndpoint)
      .then(response => {
        const tabId = getState().mainTabs.reservedTabIds[idCheckoutToken];
        dispatch({
          type: ISSUE.FETCH_ISSUE_FULFILLED,
          issue: response.data,
          tabId
        });
        console.log(ISSUE.FETCH_ISSUE_FULFILLED, response.data);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = ISSUE.FETCH_ISSUE_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.error(ISSUE.FETCH_ISSUE_REJECTED, err.response.data);
      });
  });

const getAllIssues = () => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: ISSUE.FETCH_ALL_ISSUES });
    const apiEndpoint = BASE_URL + "/api/Issues/GetAll";
    axios
      .get(apiEndpoint)
      .then(response => {
        dispatch({
          type: ISSUE.FETCH_ALL_ISSUES_FULFILLED,
          issueList: response.data
        });
        console.log(ISSUE.FETCH_ALL_ISSUES_FULFILLED, response.data);
        resolve(response.data);
      })
      .catch(err => {
        const errorId = getUUID();
        const type = ISSUE.FETCH_ALL_ISSUES_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.error(ISSUE.FETCH_ALL_ISSUES_REJECTED, err.response.data);
      });
  });

const editIssue = issue => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: ISSUE.UPDATE_ISSUE });
    const apiEndpoint = BASE_URL + "/api/Issues/Edit";
    axios
      .post(apiEndpoint, issue)
      .then(response => {
        dispatch({
          type: ISSUE.UPDATE_ISSUE_FULFILLED,
          issue: response.data
        });
        console.log(ISSUE.UPDATE_ISSUE_FULFILLED, response.data);
        resolve(response.data);
      })
      .catch(err => {
        dispatch({ type: ISSUE.UPDATE_ISSUE_REJECTED, payload: err });
        console.log(ISSUE.UPDATE_ISSUE_REJECTED, err);
        reject(err);
      });
  });

// Keep this interface alphabetical
const issueActions = {
  addIssue,
  addPost,
  editIssue,
  followIssue,
  getAllIssues,
  getIssue,
  likePost,
  unfollowIssue
};

export default issueActions;
